<!--这个是100百年芳华index的引入页面，实现方式按照图说四史写-->

<template>
  <div class="hunDred">
    <commonHeader></commonHeader>

    <img
      v-if="btnFlag"
      style="
        position: absolute;
        right: 10px;
        top: 90px;
        height: 40px;
        width: 40px;
        z-index: 999999999;
      "
      id="go-top"
      :src="require('../components/img/top.png')"
      @click="backTop"
    />

    <!--学生献礼-->

    <van-popup v-model="xsxlopen" position="left" class="wkpop">
      <div style="height: 20px">
        <van-button
          style="
            float: right;
            height: 20px;
            text-align: center;
            margin: 5px;
            border-radius: 10px;
            text-align: center;
            line-height: 20px;
          "
          @click="showxsxl"
          size="mini"
          >x</van-button
        >
      </div>
      <div style="height: 30px">
        <div
          style="
            width: 96%;
            margin-top: 10px;
            height: 30px;
            border: 2px solid pink;
            margin-left: 2%;
            margin-right: 2%;
            text-align: center;
          "
        >
          <p
            width="100px;"
            style="
              display: block;
              height: 20px;
              text-align: center;
              background: #f1d31f96;
              border-radius: 5px;
              margin: 5px;
              text-decoration: none;
              text-align: center;
              line-height: 20px;
              font-size: 13px;
            "
          >
            百年校庆学子送祝福
          </p>
        </div>
      </div>
      <!--一共两行两列-->
      <van-row>
        <!--第一行第一列,视频-->
        <van-col span="12">
          <ul>
            <div
              v-for="item in listsplz"
              style="
                margin-top: 10px;
                text-align: center;
                margin-left: 9px;
                margin-right: 9px;
                margin-bottom: 15px;
                box-shadow: -2px 0px 2px #c5c8ca, 0px -0.5px 0.5px #dfe2e6,
                  2px 0px 2px #c5c8ca, 0px 2px 2px #c5c8ca;
              "
            >
              <p class="box">
                <span
                  style="line-height: 35px; font-size: 16px; padding-left: 10px"
                >
                  {{ item.title }}
                </span>
              </p>
              <div style="width: 100%; border: solid 1px #a94f8a94">
                <img
                  :src="item.images"
                  alt=""
                  style="width: 100%"
                  @click="openpop1(item.type)"
                  v-bind:style="{ height: zfimgSize + 'px' }"
                />
              </div>
              <mt-popup
                v-model="popupVisible1"
                :closeOnClickModal="false"
                style="width: 80%; height: 50%; overflow-y: auto"
              >
                <div style="height: 30px">
                  <span
                    @click="closepop1(item.type)"
                    style="font-size: 20px; float: right; padding-right: 15px"
                    >x</span
                  >
                </div>
                <!-- <div v-if="getitemtype == 4" v-for="item4 in rdzzchildren">
                  <mt-cell
                    :title="item4.desc"
                    :to="item4.link"
                    is-link
                    :value="item4.title"
                  >
                  </mt-cell>
                </div> -->
              </mt-popup>
            </div>
          </ul>
        </van-col>
        <!--第一行第二列列,故事会-->
        <van-col span="12">
          <ul>
            <div
              v-for="item in listsyz"
              style="
                margin-top: 10px;
                text-align: center;
                margin-left: 9px;
                margin-right: 9px;
                margin-bottom: 15px;
                box-shadow: -2px 0px 2px #c5c8ca, 0px -0.5px 0.5px #dfe2e6,
                  2px 0px 2px #c5c8ca, 0px 2px 2px #c5c8ca;
              "
            >
              <p class="box">
                <span
                  style="line-height: 35px; font-size: 16px; padding-left: 10px"
                >
                  {{ item.title }}
                </span>
              </p>
              <div style="width: 100%; border: solid 1px #a94f8a94">
                <img
                  :src="item.images"
                  alt=""
                  style="width: 100%"
                  @click="openpop1(item.type)"
                  v-bind:style="{ height: zfimgSize + 'px' }"
                />
              </div>

              <mt-popup
                v-model="popupVisible1"
                :closeOnClickModal="false"
                style="width: 80%; height: 50%; overflow-y: auto"
              >
                <div style="height: 30px">
                  <span
                    @click="closepop1(item.type)"
                    style="font-size: 20px; float: right; padding-right: 15px"
                    >x</span
                  >
                </div>
                <!-- <div v-if="getitemtype == 4" v-for="item4 in rdzzchildren">
                  <mt-cell
                    :title="item4.desc"
                    :to="item4.link"
                    is-link
                    :value="item4.title"
                  >
                  </mt-cell>
                </div> -->
              </mt-popup>
            </div>
          </ul>
        </van-col>
      </van-row>
      <van-row>
        <!--第二行第一列,绘画展览-->
        <van-col span="12">
          <ul>
            <div
              v-for="item in listhhz"
              style="
                margin-top: 10px;
                text-align: center;
                margin-left: 9px;
                margin-right: 9px;
                margin-bottom: 15px;
                box-shadow: -2px 0px 2px #c5c8ca, 0px -0.5px 0.5px #dfe2e6,
                  2px 0px 2px #c5c8ca, 0px 2px 2px #c5c8ca;
              "
            >
              <p class="box">
                <span
                  style="line-height: 35px; font-size: 16px; padding-left: 10px"
                >
                  {{ item.title }}
                </span>
              </p>
              <div style="width: 100%; border: solid 1px #a94f8a94">
                <img
                  :src="item.images"
                  alt=""
                  style="width: 100%"
                  @click="openpop1(item.type)"
                  v-bind:style="{ height: zfimgSize + 'px' }"
                />
              </div>
              <mt-popup
                v-model="popupVisible1"
                :closeOnClickModal="false"
                style="width: 80%; height: 50%; overflow-y: auto"
              >
                <div style="height: 30px">
                  <span
                    @click="closepop1(item.type)"
                    style="font-size: 20px; float: right; padding-right: 15px"
                    >x</span
                  >
                </div>
                <!-- <div v-if="getitemtype == 4" v-for="item4 in rdzzchildren">
                  <mt-cell
                    :title="item4.desc"
                    :to="item4.link"
                    is-link
                    :value="item4.title"
                  >
                  </mt-cell>
                </div> -->
              </mt-popup>
            </div>
          </ul>
        </van-col>
        <!--第二行第二列,绘画展览-->
        <van-col span="12">
          <ul>
            <div
              v-for="item in listydjy"
              style="
                margin-top: 10px;
                text-align: center;
                margin-left: 9px;
                margin-right: 9px;
                margin-bottom: 15px;
                box-shadow: -2px 0px 2px #c5c8ca, 0px -0.5px 0.5px #dfe2e6,
                  2px 0px 2px #c5c8ca, 0px 2px 2px #c5c8ca;
              "
            >
              <p class="box">
                <span
                  style="line-height: 35px; font-size: 16px; padding-left: 10px"
                >
                  {{ item.title }}
                </span>
              </p>
              <div style="width: 100%; border: solid 1px #a94f8a94">
                <img
                  :src="item.images"
                  alt=""
                  style="width: 100%"
                  @click="openpop1(item.type)"
                  v-bind:style="{ height: zfimgSize + 'px' }"
                />
              </div>
              <mt-popup
                v-model="popupVisible1"
                :closeOnClickModal="false"
                style="width: 80%; height: 50%; overflow-y: auto"
              >
                <div style="height: 30px">
                  <span
                    @click="closepop1(item.type)"
                    style="font-size: 20px; float: right; padding-right: 15px"
                    >x</span
                  >
                </div>
                <!-- <div v-if="getitemtype == 4" v-for="item4 in rdzzchildren">
                  <mt-cell
                    :title="item4.desc"
                    :to="item4.link"
                    is-link
                    :value="item4.title"
                  >
                  </mt-cell>
                </div> -->
              </mt-popup>
            </div>
          </ul>
        </van-col>
      </van-row>
      <!-- <div v-for="itemxl in xllist" style="background:#8080803d;width:94%;height:33%;margin-bottom:15px;margin-top:10px;text-align:center;margin-left:3%;margin-right:3%;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;"> -->
      <!-- <div style="text-align: left;height:15">
                         <span style=" background: rgb(233 144 144 / 75%);width:100%;float:left;line-height: 35px;font-size: 16px;height:15%">
                          {{itemxl.title}}
                         </span>
                     </div> -->
      <!-- <div style="height:85%;">
                      <video
                          :src="itemv.videourl"
                           controls
                           width="100%" height="100%"
                           style=" object-fit: cover;
                           object-position: center center;max-height:400px;max-width:500px"
                          :poster="itemv.coverimg"
                      ></video>
                     </div> -->

      <!-- </div> -->
    </van-popup>

    <!-- 红色龙江弹窗 -->
    <!--改成学生献礼-->
    <!-- <div v-if="popupVisibleLongjiang" class="leaflet-popup  leaflet-zoom-animated" style="opacity: 1;top: 88px;left: 7px;z-index:999999;width:calc(100% - 14px);height:370px;">
        <div class="leaflet-popup-content-wrapper">
          <div class="leaflet-popup-content">
              <div style="height:10px;"></div>
              <mt-search v-model="searchLongjiangValue" placeholder="搜索">
              </mt-search>
              <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" infinite-scroll-immediate-check="false">
                  <div v-for="item in longjiangPlaces" style="text-align:center;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                    <p @click="locationLongjiang(item)" style="margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <img class="abc" @click="goVR(item)" :src="item.imgurl" alt="" style="width:100%;" v-bind:style="{ height: heightSize + 'px' }">
                  </div>
                </ul>
          </div>   
        </div> -->

    <!-- <div class="leaflet-popup-tip-container">
          <div class="leaflet-popup-tip"></div>
        </div> -->

    <!-- <a class="leaflet-popup-close-button" href="#course" @click="showListLongjiang">
          ×
        </a>
      </div> -->

    <!-- 红色中国弹窗 -->
    <div
      v-if="popupVisibleChina"
      class="leaflet-popup leaflet-zoom-animated"
      style="
        opacity: 1;
        top: 88px;
        left: 7px;
        z-index: 999999;
        width: calc(100% - 14px);
        height: 370px;
      "
    >
      <div class="leaflet-popup-content-wrapper">
        <!-- 首先显示中共党史分类 20210326 -->
        <div class="leaflet-popup-content" v-if="zgdsTypeShow">
          <div style="height: 10px"></div>
          <mt-search v-model="searchLongjiangValue" placeholder="搜索">
          </mt-search>
          <ul
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
            infinite-scroll-immediate-check="false"
          >
            <div
              v-for="item in zgdsType"
              style="
                text-align: center;
                margin-bottom: 15px;
                box-shadow: -2px 0px 2px #c5c8ca, 0px -0.5px 0.5px #dfe2e6,
                  2px 0px 2px #c5c8ca, 0px 2px 2px #c5c8ca;
              "
            >
              <p
                v-if="item.placename.length < 14"
                @click="locationLongjiang(item)"
                style="
                  margin-bottom: 0px;
                  height: 35px;
                  background-color: white;
                  padding-left: 10px;
                "
              >
                <span
                  style="
                    line-height: 35px;
                    font-weight: bold;
                    color: red;
                    font-size: 16px;
                  "
                  >{{ item.placename }}</span
                >
              </p>
              <p
                v-if="item.placename.length >= 14"
                @click="locationLongjiang(item)"
                style="
                  margin-bottom: 0px;
                  height: 70px;
                  background-color: white;
                  padding-left: 10px;
                "
              >
                <span
                  style="
                    line-height: 35px;
                    font-weight: bold;
                    color: red;
                    font-size: 16px;
                  "
                  >{{ item.placename }}</span
                >
              </p>
              <img
                class="abc"
                @click="goZgdsType(item)"
                :src="item.imgurl"
                alt=""
                style="width: 100%"
                v-bind:style="{ height: heightSize + 'px' }"
              />
            </div>
          </ul>
        </div>

        <div class="leaflet-popup-content" v-if="!zgdsTypeShow">
          <div style="height: 10px"></div>
          <mt-search v-model="searchChinaValue" placeholder="搜索"> </mt-search>
          <ul
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
            infinite-scroll-immediate-check="false"
          >
            <div
              v-for="item in places"
              style="
                text-align: center;
                margin-bottom: 15px;
                box-shadow: -2px 0px 2px #c5c8ca, 0px -0.5px 0.5px #dfe2e6,
                  2px 0px 2px #c5c8ca, 0px 2px 2px #c5c8ca;
              "
            >
              <p
                v-if="item.placename.length < 20"
                @click="locationChina(item)"
                style="
                  margin-bottom: 0px;
                  height: 35px;
                  background-color: white;
                  padding-left: 10px;
                "
              >
                <span
                  style="
                    line-height: 35px;
                    font-weight: bold;
                    color: red;
                    font-size: 16px;
                  "
                  >{{ item.placename }}</span
                >
              </p>
              <p
                v-if="item.placename.length >= 20 && item.placename.length < 36"
                @click="locationChina(item)"
                style="
                  margin-bottom: 0px;
                  height: 70px;
                  background-color: white;
                  padding-left: 10px;
                "
              >
                <span
                  style="
                    line-height: 35px;
                    font-weight: bold;
                    color: red;
                    font-size: 16px;
                  "
                  >{{ item.placename }}</span
                >
              </p>
              <p
                v-if="item.placename.length >= 36"
                @click="locationChina(item)"
                style="
                  margin-bottom: 0px;
                  height: 105px;
                  background-color: white;
                  padding-left: 10px;
                "
              >
                <span
                  style="
                    line-height: 35px;
                    font-weight: bold;
                    color: red;
                    font-size: 16px;
                  "
                  >{{ item.placename }}</span
                >
              </p>
              <img
                class="abc"
                @click="goVR(item)"
                :src="item.imgurl"
                alt=""
                style="width: 100%"
                v-bind:style="{ height: heightSize + 'px' }"
              />
            </div>
          </ul>
        </div>
      </div>

      <!-- <div class="leaflet-popup-tip-container">
          <div class="leaflet-popup-tip"></div>
        </div> -->

      <a
        class="leaflet-popup-close-button"
        href="#course"
        @click="showListChina"
      >
        ×
      </a>
    </div>

    <!-- 改革开放史弹窗 -->
    <div
      v-if="popupVisibleGaige"
      class="leaflet-popup leaflet-zoom-animated"
      style="
        opacity: 1;
        top: 88px;
        left: 7px;
        z-index: 999999;
        width: calc(100% - 14px);
        height: 370px;
      "
    >
      <div class="leaflet-popup-content-wrapper">
        <div class="leaflet-popup-content">
          <div style="height: 10px"></div>
          <mt-search v-model="searchGaigeValue" placeholder="搜索"> </mt-search>
          <ul
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
            infinite-scroll-immediate-check="false"
          >
            <div
              v-for="item in gaigePlaces"
              style="
                text-align: center;
                margin-bottom: 15px;
                box-shadow: -2px 0px 2px #c5c8ca, 0px -0.5px 0.5px #dfe2e6,
                  2px 0px 2px #c5c8ca, 0px 2px 2px #c5c8ca;
              "
            >
              <p
                @click="locationChina(item)"
                style="
                  margin-bottom: 0px;
                  height: 35px;
                  background-color: white;
                  padding-left: 10px;
                "
              >
                <span
                  style="
                    line-height: 35px;
                    font-weight: bold;
                    color: red;
                    font-size: 16px;
                  "
                  >{{ item.placename }}</span
                >
              </p>
              <img
                class="abc"
                @click="goVR(item)"
                :src="item.imgurl"
                alt=""
                style="width: 100%"
                v-bind:style="{ height: heightSize + 'px' }"
              />
            </div>
          </ul>
        </div>
      </div>

      <!-- <div class="leaflet-popup-tip-container">
          <div class="leaflet-popup-tip"></div>
        </div> -->

      <a
        class="leaflet-popup-close-button"
        href="#course"
        @click="showListGaige"
      >
        ×
      </a>
    </div>

    <!-- 知名校友、学生献礼 -->
    <div
      v-if="popupVisibleTlff"
      class="leaflet-popup leaflet-zoom-animated"
      style="
        opacity: 1;
        top: 88px;
        left: 7px;
        z-index: 999999;
        width: calc(100% - 14px);
        height: 370px;
      "
    >
      <div class="leaflet-popup-content-wrapper">
        <div class="leaflet-popup-content">
          <div style="height: 10px"></div>
          <mt-search v-model="searchShzyValue" placeholder="搜索"> </mt-search>
          <!--div是窗体，p是名称，img是图片--><!--这里的shzyPlaces处理一下改成校友的-->
          <ul
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
            infinite-scroll-immediate-check="false"
          >
            <div
              v-for="item in shzyPlaces"
              style="
                text-align: center;
                margin-bottom: 15px;
                box-shadow: -2px 0px 2px #c5c8ca, 0px -0.5px 0.5px #dfe2e6,
                  2px 0px 2px #c5c8ca, 0px 2px 2px #c5c8ca;
              "
            >
              <p
                @click="locationChina(item)"
                style="
                  margin-bottom: 0px;
                  height: 35px;
                  background-color: white;
                  padding-left: 10px;
                "
              >
                <span
                  style="
                    line-height: 35px;
                    font-weight: bold;
                    color: red;
                    font-size: 16px;
                  "
                  >{{ item.placename }}</span
                >
              </p>

              <img
                class="abc"
                @click="goVR(item)"
                :src="item.imgurl"
                alt=""
                style="width: 100%"
                v-bind:style="{ height: heightSize + 'px' }"
              />
            </div>
          </ul>
        </div>
      </div>

      <a
        class="leaflet-popup-close-button"
        href="#course"
        @click="showListTlff"
      >
        ×
      </a>
    </div>
    <!--历届足迹选择弹窗-->

    <div
      v-if="popupVisibleLjzj"
      class="leaflet-popup leaflet-zoom-animated"
      style="
        opacity: 1;
        top: 88px;
        left: 7px;
        z-index: 999999;
        width: calc(100% - 14px);
        height: 370px;
      "
    ></div>

    <mt-navbar v-model="selected" style="margin-bottom: 3px">
      <mt-tab-item id="2" style="color: rgb(68, 85, 102); font-weight: bold"
        ><i class="iconfont icon-shu"></i>百年芳华</mt-tab-item
      >
      <mt-tab-item id="1" style="color: rgb(68, 85, 102); font-weight: bold"
        ><i class="iconfont icon-1"></i>高山仰止</mt-tab-item
      >
      <mt-tab-item id="3" style="color: rgb(68, 85, 102); font-weight: bold"
        ><i class="iconfont icon-shidaixinrenshuo-copy"></i
        >时代新人</mt-tab-item
      >
      <mt-tab-item id="4" style="color: rgb(68, 85, 102); font-weight: bold"
        ><i class="iconfont icon-taolibi-icon-"></i>桃李芬芳</mt-tab-item
      >
    </mt-navbar>

    <!--高山仰止部分-->
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="1">
        <!--最外层div-->
        <div id="map-container-longjiang" style="width: 100%">
          <div id="gsyz" style="width: 100%; height: 100%">
            <!--伍连德-->

            <div
              v-if="wldshow"
              class="wldwrapper-content"
              v-for="(item, index) in wldlist"
            >
              <div
                @click="golink(item)"
                style="
                  width: 100%;
                  height: 100%;
                  text-align: center;
                  margin-left: 9px;
                  margin-right: 9px;
                  margin-bottom: 15px;
                  box-shadow: rgb(197 200 202) -2px 0px 2px,
                    rgb(223 226 230) 0px -0.5px 0.5px,
                    rgb(197 200 202) 2px 0px 2px, rgb(197 200 202) 0px 2px 2px;
                "
              >
                <p
                  style="
                    height: 35px;
                    text-align: left;
                    margin-bottom: 0px;
                    background-color: white;
                    padding-left: 10px;
                  "
                >
                  <span style="line-height: 35px; font-size: 16px">
                    {{ item.title }}</span
                  >
                </p>
                <img
                  :src="item.images"
                  alt=""
                  style="width: 100%; height: 160px"
                />
              </div>
            </div>

            <div
              v-if="ywhshow"
              class="wldwrapper-content"
              v-for="(item, index) in ywhlist"
            >
              <div
                @click="golink(item)"
                style="
                  width: 100%;
                  height: 100%;
                  text-align: center;
                  margin-left: 9px;
                  margin-right: 9px;
                  margin-bottom: 15px;
                  box-shadow: rgb(197 200 202) -2px 0px 2px,
                    rgb(223 226 230) 0px -0.5px 0.5px,
                    rgb(197 200 202) 2px 0px 2px, rgb(197 200 202) 0px 2px 2px;
                "
              >
                <p
                  style="
                    height: 35px;
                    text-align: left;
                    margin-bottom: 0px;
                    background-color: white;
                    padding-left: 10px;
                  "
                >
                  <span style="line-height: 35px; font-size: 16px">
                    {{ item.title }}
                  </span>
                </p>
                <img
                  :src="item.images"
                  alt=""
                  style="width: 100%; height: 160px"
                />
              </div>
            </div>

            <!-- 列表 -->
            <div class="leaflet-top leaflet-right">
              <!-- <div class="leaflet-control" style="background: #fff;border-radius:5px;border:2px solid rgba(0,0,0,0.2);padding:6px;color:rgb(68, 85, 102);font-weight:bold;" @click="showListLongjiang">列表模式</div> -->
              <dropdown
                @change-item="changeItem"
                :isshow="showPopover"
                class="leaflet-control"
                ref="gsyzdropdown"
              >
                <button
                  slot="title"
                  style="
                    color: white;
                    border: 1px solid #ff6a00;
                    width: 80px;
                    height: 28px;
                    background: linear-gradient(to bottom, #ff6034, #ee0a24);
                  "
                >
                  更多故事
                </button>
                <dropmenu slot="dropdown">
                  <dropitem value="ywh"
                    ><div @click="changwldshow()">伍连德</div></dropitem
                  >
                  <dropitem value="ywh"
                    ><div @click="changWlshow()">于维汉</div></dropitem
                  >
                  <dropitem value="dymy">大医名医</dropitem>
                  <dropitem value="wbcc">我辈传承</dropitem>
                </dropmenu>
              </dropdown>
            </div>
          </div>
        </div>
      </mt-tab-container-item>

      <!--百年芳华-->
      <mt-tab-container-item id="2">
        <div id="bnfh-container-china" style="width: 100%">
          <div id="Bnfhbnzc" style="width: 100%; height: 100%; z-index: 999998">
            <!--轮播图-->
            <van-swipe
              :autoplay="6000"
              @change="IndicatoronChange"
              touchable
              class="mint-swipe"
              ref="swiper"
            >
              <van-swipe-item v-for="item in bnfhpictures" :key="item.id">
                <img v-lazy="item.url" class="wldimg" />
                <div v-if="isMobile == null" class="prebutton">
                  <van-icon name="arrow-left" size="30" @click="pre()" />
                </div>
                <div v-if="isMobile == null" class="nextbutton">
                  <van-icon name="arrow" size="30" @click="next()" />
                </div>
                <span class="desc">
                  <a
                    href="javascript:void(0)"
                    rel="external nofollow"
                    @click="getHistory(item.id)"
                    style="color: white"
                  >
                    {{ item.title }}</a
                  >
                </span>
              </van-swipe-item>
              <div class="custom-indicator" slot="indicator">
                {{ current + 1 }}/9
              </div>
              <!-- <span style="margin:10px;bottom:25px">  {{ current + 1 }}/8</span> -->
            </van-swipe>

            <!-- 列表 -->
            <div class="leaflet-top leaflet-right">
              <dropdown
                @change-item="changeItem"
                :isshow="showPopover"
                class="leaflet-control"
                ref="bnfhdropdown"
              >
                <button
                  slot="title"
                  style="
                    color: white;
                    border: 1px solid #ff6a00;
                    width: 80px;
                    height: 28px;
                    background: linear-gradient(to bottom, #ff6034, #ee0a24);
                  "
                >
                  更多故事
                </button>
                <dropmenu slot="dropdown">
                  <dropitem value="lsbq"
                    ><div @click="lsbqchange">历史变迁</div>
                  </dropitem>
                  <dropitem value="hsjy"
                    ><div @click="kxjychange">红色基因</div></dropitem
                  >
                  <dropitem value="kxjy"
                    ><div @click="hsjychange">科学基因</div></dropitem
                  >
                  <dropitem value="kfjy"
                    ><div @click="kfjychange">开放基因</div></dropitem
                  >
                </dropmenu>
              </dropdown>
            </div>
          </div>
          <!--历史变迁到开放基因的四个pop-->
          <mt-popup
            :modal="false"
            v-model="lsbqVisible"
            position="bottom"
            class="lsbqcss"
          >
            <a
              class="leaflet-popup-close-button"
              href="#course"
              @click="closelsbg"
            >
              ×
            </a>
          </mt-popup>
          <mt-popup
            :modal="false"
            class="lsbqcss"
            v-model="kxjyVisible"
            position="bottom"
          >
            <a
              class="leaflet-popup-close-button"
              href="#course"
              @click="closekxjy"
            >
              ×
            </a>
          </mt-popup>
          <mt-popup
            :modal="false"
            class="lsbqcss"
            v-model="hsjyVisible"
            position="bottom"
          >
            <a
              class="leaflet-popup-close-button"
              href="#course"
              @click="closehsjy"
            >
              ×
            </a>
          </mt-popup>
          <mt-popup
            :modal="false"
            class="lsbqcss"
            v-model="kfjyVisible"
            position="bottom"
          >
            <a
              class="leaflet-popup-close-button"
              href="#course"
              @click="closekfjy"
            >
              ×
            </a>
          </mt-popup>
        </div>
      </mt-tab-container-item>
      <!--时代新人-->
      <mt-tab-container-item id="3">
        <div id="map-container-gaige" style="width: 100%">
          <div
            id="mapRedGaige"
            style="width: 100%; height: 100%; z-index: 999998"
          >
            <!-- 列表 -->
            <div class="leaflet-top leaflet-right">
              <!-- <div class="leaflet-control" style="background: #fff;border-radius:5px;border:2px solid rgba(0,0,0,0.2);padding:6px;color:rgb(68, 85, 102);font-weight:bold;" @click="showListGaige">列表模式</div> -->
              <dropdown
                @change-item="changeItem"
                :isshow="showPopover"
                class="leaflet-control"
                ref="sdxrdropdown"
              >
                <button
                  slot="title"
                  style="
                    color: white;
                    border: 1px solid #ff6a00;
                    width: 80px;
                    height: 28px;
                    background: linear-gradient(to bottom, #ff6034, #ee0a24);
                  "
                >
                  更多故事
                </button>
                <dropmenu slot="dropdown">
                  <dropitem value="zrdd"
                    ><div @click="showListGaige">责任担当</div></dropitem
                  >
                  <dropitem value="sdxw"
                    ><div @click="showListGaige">时代新我</div></dropitem
                  >
                  <dropitem value="yzlx">
                    <div @click="yzRoute">义诊路线</div></dropitem
                  >
                  <dropitem value="xxlx">
                    <div @click="XRoute">下乡路线</div></dropitem
                  >
                </dropmenu>
              </dropdown>
            </div>
          </div>
        </div>
      </mt-tab-container-item>

      <!--桃李芬芳-->
      <mt-tab-container-item id="4">
        <div id="map-container-shzy" style="width: 100%">
          <div
            id="cesiumContainer"
            style="width: 100%; height: 100%; z-index: 999998"
          >
            <div class="leaflet-top leaflet-right">
              <!-- <div class="leaflet-control" style="background: #fff;border-radius:5px;border:2px solid rgba(0,0,0,0.2);padding:6px;color:rgb(68, 85, 102);font-weight:bold;" @click="showListTlff">列表模式</div> -->
              <dropdown
                @change-item="changeItem"
                :isshow="showPopover"
                class="leaflet-control"
                ref="tlffdropdown"
              >
                <button
                  slot="title"
                  style="
                    color: white;
                    border: 1px solid #ff6a00;
                    width: 80px;
                    height: 28px;
                    background: linear-gradient(to bottom, #ff6034, #ee0a24);
                  "
                >
                  更多故事
                </button>
                <dropmenu slot="dropdown">
                  <dropitem value="zmxy"
                    ><div @click="showListLongjiang">知名校友</div></dropitem
                  >
                  <dropitem value="xsxl"
                    ><div @click="showxsxl">学生献礼</div>
                  </dropitem>
                </dropmenu>
              </dropdown>
            </div>
            <div class="leaflet-bottom leaflet-right">
              <div
                class="leaflet-control"
                style="
                  background: #fff;
                  border-radius: 5px;
                  border: 2px solid rgba(0, 0, 0, 0.2);
                  padding: 6px;
                  color: rgb(68, 85, 102);
                  font-weight: bold;
                "
                @click="showLjzj"
              >
                历届足迹
              </div>
            </div>
          </div>
        </div>
        <mt-actionsheet :actions="actions" v-model="popupVisibleLjzj">
        </mt-actionsheet>
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>

<script>
import dropdown from "./../components/drop/dropdown.vue";
import dropmenu from "./../components/drop/dropmenu.vue";
import dropitem from "./../components/drop/dropitem.vue";

import { Toast } from "vant";
import Cesium from "cesium/Cesium";
import widgets from "cesium/Widgets/widgets.css";
import Ydgj from "../assets/hsz.png";
import openUrl from "./../utils/openUrl";
// import IndexApi from "../api/learingInd.js";
import cfg from "./../utils/config";
import Vue from "vue";
import L from "leaflet";
import axios from "axios";
import Addr from "./../utils/getAPI";
import commonHeader from "./../components/common-header.vue";

export default {
  name: "hunDred",

  data() {
    return {
      //====
      zfimgSize: 260,
      lsbqVisible: false,
      hsjyVisible: false,
      kxjyVisible: false,
      kfjyVisible: false,
      wldshow: true,
      ywhshow: false,
      xsxlopen: false,
      wldlist: [
        {
          publishTime: "2020-07-10",
          // hospitalImg: "http://210.46.80.153:8082/qiniu/school/0.jpg",
          // images: ["http://210.46.80.153:8082/qiniu/sizheng/wuliande.jpg"],
          hospitalImg: "http://49.232.195.119/qiniu/school/0.jpg",
          images: ["http://49.232.195.119/qiniu/sizheng/wuliande.jpg"],
          types: 1,
          properties: 14,
          hospitalId: 1,
          link: "http://beyond.3dnest.cn/play/?m=ac6bc9d2_1Va5_b6f9&from=groupmessage&isappinstalled",
          id: 303,
          hospitalName: "哈尔滨医科大学校部",
          title: "伍连德纪念馆",
          content:
            "伍连德纪念馆位于保障街140号,它曾是原东北防疫管理处,也是哈尔滨医科大学前身——哈尔滨医学专门学校的旧址",
        },
        { types: 2, title: "伍连德生平" },
        { types: 3, title: "伍连德影视记录" },
      ],
      ywhlist: [
        {
          publishTime: "2020-07-10",

          // hospitalImg: "http://210.46.80.153:8082/qiniu/school/0.jpg",
          // images: ["http://210.46.80.153:8082/qiniu/sizheng/wuliande.jpg"],
          hospitalImg: "http:// 49.232.195.119:8082/qiniu/school/0.jpg",
          images: ["http:// 49.232.195.119:8082/qiniu/sizheng/wuliande.jpg"],
          types: 1,
          properties: 14,
          hospitalId: 1,
          link: "http://beyond.3dnest.cn/play/?m=ac6bc9d2_1Va5_b6f9&from=groupmessage&isappinstalled",
          id: 303,
          hospitalName: "哈尔滨医科大学校部",
          title: "于维汉纪念馆",
          content:
            "伍连德纪念馆位于保障街140号,它曾是原东北防疫管理处,也是哈尔滨医科大学前身——哈尔滨医学专门学校的旧址",
        },
        {
          title: "于维汉生平",
        },
        { title: "于维汉影视记录" },
      ],
      //下拉菜单

      showPopover: false,

      //轮播图数据
      bnfhpictures: [
        {
          title: "百年历史",
          id: 1,
          url: Addr.getCdnAddr() + "qiniu/yidabnzc/bnfh/ydbn/yida194802.png",
        },
        {
          title: "1926年9月",
          id: 2,
          url: Addr.getCdnAddr() + "qiniu/yidabnzc/bnfh/ydbn/yida1926.png",
        },
        {
          title: "1928年1月",
          id: 3,
          url: Addr.getCdnAddr() + "qiniu/yidabnzc/bnfh/ydbn/yida1928.png",
        },
        {
          title: "1931年11月",
          id: 4,
          url: Addr.getCdnAddr() + "qiniu/yidabnzc/bnfh/ydbn/yida1931.png",
        },
        {
          title: "1932年10月",
          id: 5,
          url: Addr.getCdnAddr() + "qiniu/yidabnzc/bnfh/ydbn/yida1932.png",
        },
        {
          title: "1938年1月",
          id: 6,
          url: Addr.getCdnAddr() + "qiniu/yidabnzc/bnfh/ydbn/yida1938.png",
        },

        {
          title: "1940年9月",
          id: 7,
          url: Addr.getCdnAddr() + "qiniu/yidabnzc/bnfh/ydbn/yida1940.png",
        },
        {
          title: "1946年7月",
          id: 8,
          url: Addr.getCdnAddr() + "qiniu/yidabnzc/bnfh/ydbn/yida1946.png",
        },

        {
          title: "1948年4月",
          id: 9,
          url: Addr.getCdnAddr() + "qiniu/yidabnzc/bnfh/ydbn/yida194804.png",
        },
      ],
      //自定义指示器
      current: 0,
      //思维导图数据插件
      jm: null,
      goto100special: false,
      startShow: true,
      isMobile: true,
      searchLongjiangValue: "",
      searchChinaValue: "",
      searchGaigeValue: "",
      searchShzyValue: "",
      btnFlag: false, //回到顶部
      mapLongjiang: null,
      mapChina: null,
      popupVisibleLongjiang: false,
      popupVisibleChina: false,
      popupVisibleGaige: false,
      popupVisibleTlff: false,
      popupVisibleLjzj: false,
      heightSize: 120,
      bnfhheightSize: 150,
      allShzyPlaces: [],
      shzyPlaces: [],
      allGaigePlaces: [],
      gaigePlaces: [],
      //首先显示中共党史分类 20210326
      zgdsTypeShow: true,
      //用cesium做飞线图
      viewer: null,
      sdxrviewer: null,
      submit: false,
      sdxrsubmit: false,
      //桃李芬芳数据
      tlff: null,
      //历届毕业生
      actions: [
        {
          name: "2021届",
          method: this.showcesium, // 调用methods中的函数
        },
        {
          name: "2020届",
          method: this.showcesium, // 调用methods中的函数
        },
        {
          name: "2019届",
          method: this.showcesium,
        },
      ],
      zgdsOldType: [
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/196special/196special.jpg",
          subtype: 4,
          placename: "十九届六中全会学习专题",
        },
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/100special/100special.jpg",
          subtype: 3,
          placename:
            "习近平总书记在庆祝中国共产党成立100周年大会上的重要讲话学习辅导",
        },
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/dsxx.png",
          subtype: 0,
          placename: "党史学习",
          hasChildren: true,
          children: [
            {
              imgurl: Addr.getCdnAddr() + "qiniu/four/xjpjh.jpg",
              subtype: -1,
              placename: "习近平讲话",
            },
            {
              imgurl: Addr.getCdnAddr() + "qiniu/four/dzs.png",
              subtype: 0,
              placename: "电子书",
            },
          ],
        },
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/hsjy.png",
          subtype: 1,
          placename: "红色记忆",
        },
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/yxzg.png",
          subtype: 2,
          placename: "英雄赞歌",
        },
      ],
      zgdsType: [
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/196special/196special.jpg",
          subtype: 4,
          placename: "十九届六中全会学习专题",
        },
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/100special/100special.jpg",
          subtype: 3,
          placename:
            "习近平总书记在庆祝中国共产党成立100周年大会上的重要讲话学习辅导",
        },
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/dsxx.png",
          subtype: 0,
          placename: "党史学习",
          hasChildren: true,
          children: [
            {
              imgurl: Addr.getCdnAddr() + "qiniu/four/xjpjh.jpg",
              subtype: -1,
              placename: "习近平讲话",
            },
            {
              imgurl: Addr.getCdnAddr() + "qiniu/four/dzs.png",
              subtype: 0,
              placename: "电子书",
            },
          ],
        },
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/hsjy.png",
          subtype: 1,
          placename: "红色记忆",
        },
        {
          imgurl: Addr.getCdnAddr() + "qiniu/four/yxzg.png",
          subtype: 2,
          placename: "英雄赞歌",
        },
      ],
      allLongjiangPlaces: [],
      longjiangPlaces: [],
      allPlaces: [],
      places: [],
      selected: "2",

      listsplz: [
        {
          type: "4",
          title: "视频录制送祝福",
          images: Addr.getCdnAddr() + "qiniu/party20pic/rdzz.png",
          // link: "https://www.12371.cn/2017/10/27/ARTI1509103656574313.shtml",
          // button: "更多报告",
        },
      ],
      listsyz: [
        {
          type: "4",
          title: "摄影展",
          images: Addr.getCdnAddr() + "qiniu/party20pic/rdzz.png",
          // link: "https://www.12371.cn/2017/10/27/ARTI1509103656574313.shtml",
          // button: "更多报告",
        },
      ],
      listhhz: [
        {
          type: "4",
          title: "绘画展",
          images: Addr.getCdnAddr() + "qiniu/party20pic/rdzz.png",
          // link: "https://www.12371.cn/2017/10/27/ARTI1509103656574313.shtml",
          // button: "更多报告",
        },
      ],
      listydjy: [
        {
          type: "4",
          title: "医大寄语",
          images: Addr.getCdnAddr() + "qiniu/party20pic/rdzz.png",
          // link: "https://www.12371.cn/2017/10/27/ARTI1509103656574313.shtml",
          // button: "更多报告",
        },
      ],
    };
  },
  components: {
    commonHeader,
    dropdown,
    dropmenu,
    dropitem,
  },
  methods: {
    //伍连德、于维汉div切换
    changWlshow() {
      this.wldshow = false;
      this.ywhshow = true;
    },
    changwldshow() {
      this.wldshow = true;
      this.ywhshow = false;
    },

    //点击伍连德div走链接
    golink(item) {
      switch (item.types) {
        case 1:
          openUrl.open(item.link);
          break;
        case 2:
          break;
        case 3:
          break;
        default:
          break;
      }
      // if(item.types==1){

      // }else{

      //   return;
      // }
    },

    initcesium(pramas) {
      this.viewer = new Cesium.Viewer(pramas, {
        baseLayerPicker: false, //地图切换控件(底图以及地形图)是否显示,默认显示true
        timeline: false,
        animation: false,
        vrButton: false,
        homeButton: false,
        orderIndependentTranslucency: false,
        sceneModePicker: false,
        infoBox: false,
        scene3DOnly: true,
        navigationHelpButton: false,
        selectionIndicator: false, //entity绿色框框
        geocoder: false,
        fullscreenButton: false,
        maximumScreenSpaceError: 8, // Temporary workaround for low memory mobile devices - Increase maximum error to 8.
        maximumNumberOfLoadedTiles: 10, // Temporary workaround for low memory mobile devices - Decrease (disable) tile cache.
      });

      //添加天地图地图作为底图
      let imageryLayers = this.viewer.imageryLayers;

      let baseLayer = imageryLayers.get(0);
      //天地图密码
      //tk=b256e08b9f972a2c4677ab5608a305ff
      let url =
        "http://{s}.tianditu.com/img_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=img&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";
      let url1 =
        "http://{s}.tianditu.com/cva_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=cva&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";

      imageryLayers.addImageryProvider(
        new Cesium.WebMapTileServiceImageryProvider({
          url: url,
          layer: "img",
          style: "default",
          format: "tiles",
          tileMatrixSetID: "w",
          // credit: new Cesium.Credit('天地图全球影像服务'),
          subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
          maximumLevel: 10,
        }),
        1
      );

      imageryLayers.addImageryProvider(
        new Cesium.WebMapTileServiceImageryProvider({
          url: url1,
          layer: "cva",
          style: "default",
          format: "tiles",
          tileMatrixSetID: "w",
          // credit: new Cesium.Credit('天地图全球影像服务'),
          subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
          maximumLevel: 10,
        }),
        2
      );
    },
    changeItem(e) {
      console.log(e);
    },
    //历史变迁
    lsbqchange() {
      this.lsbqVisible = true;
      this.hsjyVisible = false;
      this.kxjyVisible = false;
      this.kfjyVisible = false;
    },

    //红色基因
    hsjychange() {
      this.hsjyVisible = true;
      this.lsbqVisible = false;
      this.kxjyVisible = false;
      this.kfjyVisible = false;
    },
    //科学基因
    kxjychange() {
      this.kxjyVisible = true;
      this.lsbqVisible = false;
      this.hsjyVisible = false;
      this.kfjyVisible = false;
    },
    //开发基因
    kfjychange() {
      this.kfjyVisible = true;
      this.lsbqVisible = false;
      this.hsjyVisible = false;
      this.kxjyVisible = false;
    },

    closelsbg() {
      this.lsbqVisible = false;
    },
    closehsjy() {
      this.hsjyVisible = false;
    },

    closekxjy() {
      this.kxjyVisible = false;
    },
    closekfjy() {
      this.kfjyVisible = false;
    },
    //轮播图点击时间返回的地址url 统一到一个界面，通过不同的value值进行渲染
    getHistory(val) {
      // return 'http://localhost:8080/#/bnfhPicture='+val
      console.log("图片id", val);

      this.$router.push({
        path: "/bnfhpicture",
        params: {
          id: val,
        },
      });
    },
    //轮播图前后翻页功能
    pre() {
      console.log(this.$refs.swiper);
      this.$refs.swiper.prev();
    },
    next() {
      this.$refs.swiper.next();
    },
    //自定义指示器方法
    IndicatoronChange(index) {
      this.current = index;
    },
    //思维导图初始化数据
    swdt_data: function () {
      var mind = {
        /* 元数据，定义思维导图的名称、作者、版本等信息 */
        meta: {
          name: "yidahistory",
          author: "hslm",
          version: "1.0",
        },
        /* 数据格式声明 */
        format: "node_tree",
        /* 数据内容 */
        data: {
          id: "root",
          topic: "医大百年",
          children: [
            {
              id: "1926",
              topic: "时间:1926年9月",
              direction: "left",
              //   expanded: false,
              children: [
                { id: "192601", topic: "校名:滨江医学专门学校" },
                { id: "192602", topic: "校址:哈尔滨市道外区保障街140号" },
              ],
            },
            {
              id: "1928",
              topic: "时间:1928年1月",
              direction: "left",
              //   expanded: false,
              children: [
                { id: "192801", topic: "校名:哈尔滨医学专门院校" },
                { id: "192802", topic: "校址:哈尔滨市南岗区红军街77号" },
              ],
            },
            {
              id: "1931",
              topic: "时间:1931年11月",
              direction: "left",
              //   expanded: false,
              children: [
                { id: "193101", topic: "校名:中国工农红军军医学校" },
                { id: "193102", topic: "校址:江西·瑞金" },
              ],
            },
            {
              id: "1932",
              topic: "时间:1932年10月",
              direction: "left",
              //   expanded: false,
              children: [
                { id: "193201", topic: "校名:中国工农红军卫生学校" },
                { id: "193202", topic: "校址:兴国" },
              ],
            },
            {
              id: "1938",
              topic: "时间:1938年1月",
              direction: "right",
              //   expanded: false,
              children: [
                { id: "193801", topic: "校名:原哈尔滨医科大学" },
                {
                  id: "193802",
                  topic: "校址:南岗区东大直街精神病院(现哈医大门诊部大楼址)",
                },
              ],
            },
            {
              id: "1940",
              topic: "时间:1940年9月",
              direction: "right",
              //   expanded: false,
              children: [
                { id: "194001", topic: "校名:中国医科大学" },
                { id: "194002", topic: "校址:陕西·延安" },
              ],
            },

            {
              id: "1946",
              topic: "时间:1946年7月",
              direction: "right",
              //   expanded: false,
              children: [
                { id: "194601", topic: "校名:中国医科大学" },
                { id: "194602", topic: "校址:兴山(鹤岗)" },
              ],
            },
            {
              id: "1948",
              topic: "时间:1948年2月",
              direction: "right",
              //   expanded: false,
              children: [
                { id: "194801", topic: "校名:中国医科大学第一分校" },
                { id: "194802", topic: "校址:吉林省延边州龙井市" },
              ],
            },
            {
              id: "1949",
              topic: "时间:1948年4月",
              direction: "right",
              //   expanded: false,
              children: [
                { id: "19480401", topic: "校名:哈尔滨医科大学" },
                {
                  id: "19480402",
                  topic: "校址:哈尔滨市南岗区文庙街25号哈尔滨工程大学院内",
                },
              ],
            },
          ],
        },
      };

      var options = {
        container: "jsmind_container",
        editable: false,
        theme: "danger",
        layout: {
          hspace: 15, // 节点之间的水平间距
          vspace: 15, // 节点之间的垂直间距
          pspace: 13, // 节点与连接线之间的水平间距（用于容纳节点收缩/展开控制器）
        },
        menuOpts: {
          showMenu: false,
        },
      };

      this.jm = new jsMind(options);
      this.jm.show(mind);
    },
    //思维导图点击节点事件
    swdtclick() {
      console.log("jsmind_container click");
      console.log(this.jm.get_selected_node()); //获得被选中节点信息
    },

    //是否是开屏按钮跳转过来的
    checkGoto100Special() {
      if (
        localStorage.getItem("goto100special") != null &&
        localStorage.getItem("goto100special") == "yes"
      ) {
        this.goto100special = true;
        localStorage.removeItem("goto100special");
        this.showListChina();
      }
    },
    //vue 回到顶部 https://blog.csdn.net/qq_36070288/article/details/84765139
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        // console.log("scrollTop is"+that.scrollTop);
        //动态改变回到顶部按钮的位置
        if (document.getElementById("go-top")) {
          document.getElementById("go-top").style.top =
            that.scrollTop + 350 + "px";
        }
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    locationLongjiang(item) {
      this.mapLongjiang.setView([item.lat, item.lon], 14);
      this.showListLongjiang();
    },
    locationChina(item) {
      console.log("桃李天下的列表数据", item);

      this.mapChina.setView([item.lat, item.lon], 9);
      this.showListChina();
    },
    showListChina() {
      console.log("百年芳华");
      this.popupVisibleChina = !this.popupVisibleChina;
      if (this.popupVisibleChina == false) {
        this.zgdsTypeShow = false;
        //20210406 fix bug
        this.zgdsType = this.zgdsOldType;
        //fix bug
        this.places = this.allPlaces;
      }
      if (this.popupVisibleChina == true) {
        this.zgdsTypeShow = true;
      }
    },
    showListLongjiang() {
      console.log("高山仰止");
      this.popupVisibleLongjiang = !this.popupVisibleLongjiang;
    },
    showxsxl() {
      this.xsxlopen = !this.xsxlopen;
    },
    showListGaige() {
      console.log("时代新人");
      this.popupVisibleGaige = !this.popupVisibleGaige;
    },
    showListTlff() {
      console.log("桃李芬芳");
      this.popupVisibleTlff = !this.popupVisibleTlff;
    },
    showLjzj() {
      this.popupVisibleLjzj = !this.popupVisibleLjzj;
    },
    setSize() {
      //1 index-map-list
      if (document.getElementById("map-container-longjiang")) {
        //设置地图高度
        document.getElementById("map-container-longjiang").style.height =
          window.innerHeight - 128 + "px"; //167
      }
      if (document.getElementById("bnfh-container-china")) {
        //设置地图高度
        document.getElementById("bnfh-container-china").style.height =
          window.innerHeight - 128 + "px"; //167
      }
      if (document.getElementById("map-container-gaige")) {
        //设置地图高度
        document.getElementById("map-container-gaige").style.height =
          window.innerHeight - 128 + "px"; //167
      }
      if (document.getElementById("map-container-shzy")) {
        //设置地图高度
        document.getElementById("map-container-shzy").style.height =
          window.innerHeight - 128 + "px"; //167
      }
      //新增十九届六中全会内容
      if (document.getElementById("map-container-shijiuliu")) {
        //设置地图高度
        document.getElementById("map-container-shijiuliu").style.height =
          window.innerHeight - 128 + "px"; //167
      }
    },
    goZgdsType(item) {
      let subtype = item.subtype;
      let hasChildren = item.hasChildren;

      if (hasChildren) {
        // this.$set(this.$data,"zgdsType",item.children);
        this.zgdsType = item.children;
        //重新渲染
        this.$forceUpdate();
      } else {
        console.log("subtype is:", subtype);
        this.zgdsTypeShow = false;
        //20210406 fix bug
        this.zgdsType = this.zgdsOldType;
        //fix bug
        this.allPlaces = this.places;
        this.places = this.places.filter((it) => it.subtype == subtype);
        console.log("过滤后的this.places.", this.places);
      }
    },
    goVR(place) {
      //window.location.href = place.yunurl;
      openUrl.openInExplorer(place.yunurl);
    },
    loadMore() {
      this.loading = true;
      setTimeout(() => {
        // let last = this.list[this.list.length - 1];
        // for (let i = 1; i <= 10; i++) {
        //   this.list.push(last + i);
        // }
        this.loading = false;
      }, 2500);
    },
    mapInit() {
      //leaflet 自定义图标 https://blog.csdn.net/funkstill/article/details/85773103
      //自定义图标 党旗
      //定义icon类以创建一组图标使用相同属性的图标
      let LeafIcon = L.Icon.extend({
        options: {
          // shadowUrl: "./image/leaf-shadow.png",
          iconSize: [30, 30],
          // shadowSize: [50, 64],
          // iconAnchor: [0, 0],
          // shadowAnchor: [4, 62],
          popupAnchor: [0, -10],
        },
      });
      let redIcon = new LeafIcon({
        iconUrl: require("../components/img/dang.png"),
      });

      //百年芳华影像start
      // let map = L.map("bnfh", {
      //   center: [45.74740199642105, 126.65817975997926],
      //   zoom: 11
      // });
      // // 影像
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(map);
      // // 地名标注
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(map);
      // // 边界
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(map);

      // console.log(_self.schools);

      // _self.schools.forEach(item => {
      //   var linkComponent = Vue.extend({
      //     // template: '<a @click="goArea('+item.name+','+item.img+')">' + item.name + '</a>',
      //     template: '<a @click="goArea()">' + item.name + "</a>",
      //     methods: {
      //       goArea() {
      //         //window.location.href = item.link;
      //         openUrl.open(item.link);
      //       }
      //     }
      //   });
      //   var component = new linkComponent().$mount();

      //   var name = item.name;
      //   var marker = L.marker([item.latitude, item.longitude])
      //     .addTo(map)
      //     .bindPopup(
      //       component.$el
      //       // '<a>' + item.name + '</a>'

      //       // '<a href="' +
      //       // item.link +
      //       // "?name=" +
      //       // encodeURI(item.name) +
      //       // "&img=" +
      //       // item.img +
      //       // '">' +
      //       // item.name +
      //       // "></a>"
      //     );
      // });

      //百年芳华影像end
      // this.mapLongjiang = L.map("mapRedLongjiang", {
      //   center: [37.71859032558816, 105.70358276367189],
      //   zoom: 4
      // });
      // // 影像
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(this.mapLongjiang);
      // // // 地名标注
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(this.mapLongjiang);
      // // 边界
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(this.mapLongjiang);
      // //设置地图高度
      // document.getElementById("map-container").style.height =
      //   window.innerHeight - 128 + "px";
      // this.mapChina = L.map("mapRedChina", {
      //   center: [37.71859032558816, 105.70358276367189],
      //   zoom: 4
      // });
      // // 影像
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(this.mapChina);
      // // 地名标注
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(this.mapChina);
      // // 边界
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(this.mapChina);

      // this.mapGaige = L.map("mapRedGaige", {
      //   center: [37.71859032558816, 105.70358276367189],
      //   zoom: 4
      // });
      // // 影像
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(this.mapGaige);
      // // 地名标注
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(this.mapGaige);
      // // 边界
      // L.tileLayer(
      //   "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
      //   {
      //     subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
      //   }
      // ).addTo(this.mapGaige);
      //时代新人的
      this.sdxrviewer = new Cesium.Viewer("mapRedGaige", {
        baseLayerPicker: false, //地图切换控件(底图以及地形图)是否显示,默认显示true
        timeline: false,
        animation: false,
        vrButton: false,
        homeButton: false,
        orderIndependentTranslucency: false,
        sceneModePicker: false,
        infoBox: false,
        scene3DOnly: true,
        navigationHelpButton: false,
        selectionIndicator: false, //entity绿色框框
        geocoder: false,
        fullscreenButton: false,
        maximumScreenSpaceError: 8, // Temporary workaround for low memory mobile devices - Increase maximum error to 8.
        maximumNumberOfLoadedTiles: 10, // Temporary workaround for low memory mobile devices - Decrease (disable) tile cache.
      });

      //添加天地图地图作为底图
      let sdxrimageryLayers = this.sdxrviewer.imageryLayers;

      let sdxrbaseLayer = sdxrimageryLayers.get(0);
      //天地图密码
      //tk=b256e08b9f972a2c4677ab5608a305ff
      let sdxrurl =
        "http://{s}.tianditu.com/img_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=img&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";
      let sdxrurl1 =
        "http://{s}.tianditu.com/cva_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=cva&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";

      sdxrimageryLayers.addImageryProvider(
        new Cesium.WebMapTileServiceImageryProvider({
          url: sdxrurl,
          layer: "img",
          style: "default",
          format: "tiles",
          tileMatrixSetID: "w",
          // credit: new Cesium.Credit('天地图全球影像服务'),
          subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
          maximumLevel: 10,
        }),
        1
      );

      sdxrimageryLayers.addImageryProvider(
        new Cesium.WebMapTileServiceImageryProvider({
          url: sdxrurl1,
          layer: "cva",
          style: "default",
          format: "tiles",
          tileMatrixSetID: "w",
          // credit: new Cesium.Credit('天地图全球影像服务'),
          subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
          maximumLevel: 10,
        }),
        2
      );

      //这里是桃李芬芳的

      //cesium
      this.viewer = new Cesium.Viewer("cesiumContainer", {
        baseLayerPicker: false, //地图切换控件(底图以及地形图)是否显示,默认显示true
        timeline: false,
        animation: false,
        vrButton: false,
        homeButton: false,
        orderIndependentTranslucency: false,
        sceneModePicker: false,
        infoBox: false,
        scene3DOnly: true,
        navigationHelpButton: false,
        selectionIndicator: false, //entity绿色框框
        geocoder: false,
        fullscreenButton: false,
        maximumScreenSpaceError: 8, // Temporary workaround for low memory mobile devices - Increase maximum error to 8.
        maximumNumberOfLoadedTiles: 10, // Temporary workaround for low memory mobile devices - Decrease (disable) tile cache.
      });

      //添加天地图地图作为底图
      let imageryLayers = this.viewer.imageryLayers;

      let baseLayer = imageryLayers.get(0);
      //天地图密码
      //tk=b256e08b9f972a2c4677ab5608a305ff
      let url =
        "http://{s}.tianditu.com/img_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=img&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";
      let url1 =
        "http://{s}.tianditu.com/cva_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=cva&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";

      imageryLayers.addImageryProvider(
        new Cesium.WebMapTileServiceImageryProvider({
          url: url,
          layer: "img",
          style: "default",
          format: "tiles",
          tileMatrixSetID: "w",
          // credit: new Cesium.Credit('天地图全球影像服务'),
          subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
          maximumLevel: 10,
        }),
        1
      );

      imageryLayers.addImageryProvider(
        new Cesium.WebMapTileServiceImageryProvider({
          url: url1,
          layer: "cva",
          style: "default",
          format: "tiles",
          tileMatrixSetID: "w",
          // credit: new Cesium.Credit('天地图全球影像服务'),
          subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
          maximumLevel: 10,
        }),
        2
      );
      //====

      let _self = this;

      console.log(_self.places);

      _self.places.forEach((item) => {
        var linkComponent = Vue.extend({
          template: '<a @click="goArea()">' + item.placename + "</a>",
          methods: {
            goArea() {
              openUrl.openInExplorer(item.yunurl);
            },
          },
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.lat, item.lon], { icon: redIcon })
          .addTo(this.mapChina)
          .bindPopup(component.$el);
      });

      //红色龙江的标注
      _self.longjiangPlaces.forEach((item) => {
        var linkComponent = Vue.extend({
          template: '<a @click="goArea()">' + item.placename + "</a>",
          methods: {
            goArea() {
              openUrl.openInExplorer(item.yunurl);
            },
          },
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.lat, item.lon], { icon: redIcon })
          .addTo(this.mapLongjiang)
          .bindPopup(component.$el);
      });

      //红色龙江的标注
      _self.longjiangPlaces.forEach((item) => {
        var linkComponent = Vue.extend({
          template: '<a @click="goArea()">' + item.placename + "</a>",
          methods: {
            goArea() {
              openUrl.openInExplorer(item.yunurl);
            },
          },
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.lat, item.lon], { icon: redIcon })
          .addTo(this.mapLongjiang)
          .bindPopup(component.$el);
      });

      //改革开放史的标注
      _self.gaigePlaces.forEach((item) => {
        var linkComponent = Vue.extend({
          template: '<a @click="goArea()">' + item.placename + "</a>",
          methods: {
            goArea() {
              openUrl.openInExplorer(item.yunurl);
            },
          },
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.lat, item.lon], { icon: redIcon })
          .addTo(this.mapGaige)
          .bindPopup(component.$el);
      });

      this.mapChina.invalidateSize();
      this.mapLongjiang.invalidateSize();
      // this.mapGaige.invalidateSize();
      // this.mapTlff.invalidateSize();
    },

    init: function () {
      //初始化请求数据 这里用了服务器的redis列表 需要新增一个redis列表
      console.log(
        "地址是",
        Addr.getGoNewAPIPrefix() + "red/listRed?pageNum=1&pageRow=1000"
      );
      axios
        .get(Addr.getGoNewAPIPrefix() + "red/listRed?pageNum=1&pageRow=1000")
        .then((res) => {
          console.log("res is:", res);

          if (res.data.returnCode == 100) {
            this.places = [];
            this.longjiangPlaces = [];
            this.gaigePlaces = [];
            this.shzyPlaces = [];

            res.data.returnData.list.forEach((item) => {
              console.log("  res.data.returnData.list.", item);
              //红色中国-->中共党史
              if (item.type == 0) {
                console.log("------0", item.type);
                this.places.push(item);
              }
              //红色龙江-->新中国史
              if (item.type == 1) {
                console.log("------1", item.type);
                this.longjiangPlaces.push(item);
              }
              // 改革开放史
              if (item.type == 2) {
                console.log("------2", item.type);
                this.gaigePlaces.push(item);
              }
              // 社会主义史
              if (item.type == 3) {
                this.shzyPlaces.push(item);
                console.log("------3", item.type);
                console.log(this.shzyPlaces);
              }
            });
            // //search前备份
            // this.allPlaces=this.places;
            // //search前备份
            // this.allLongjiangPlaces=this.longjiangPlaces;
            // //search前备份
            // this.allGaigePlaces=this.gaigePlaces;
            //search前备份
            this.allShzyPlaces = this.shzyPlaces;

            this.mapInit();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 首页搜索
    goSeach: function () {
      this.$router.push({ path: "/search/" });
    },
    // 搜索处理
    onblurEvent: function () {
      if (this.searchName === "") {
        this.seachWt = "65px";
      } else {
        this.seachWt = "90%";
      }
    },
    focusEvent: function () {
      this.seachWt = "90%";
    },
    //添加飞线图
    //cesium飞线图
    showRoute(slescttiff) {
      this.submit = false;
      console.log("red");
      console.log(this.viewer);
      this.viewer.entities.removeAll();
      slescttiff.forEach((item) => {
        console.log(item);
        this.addFootPrint(item);
      }, this);

      this.addFootLineDash(slescttiff);
      this.viewer.camera.setView({
        // Cesium的坐标是以地心为原点，一向指向南美洲，一向指向亚洲，一向指向北极州
        // fromDegrees()方法，将经纬度和高程转换为世界坐标
        destination: Cesium.Cartesian3.fromDegrees(
          126.61993,
          45.701417,
          5000000.0
        ),
        orientation: {
          // 指向
          heading: 6.283185307179581,
          // 视角
          pitch: -1.5688168484696687,
          roll: 0.0,
        },
      });
    },
    addFootPrint(item) {
      // console.log("item is");
      // console.log(item);

      // var redLine = viewer.entities.add({
      // 	name: 'Red arrow',
      // 	polyline: {
      // 		positions: Cesium.Cartesian3.fromDegreesArrayHeights([beijingLocation.longitude, beijingLocation.latitude, 1500,
      // 		item.lon, item.lat, 1500]),
      // 		width: 5,
      // 		followSurface: true,
      // 		material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.RED)
      // 	}

      // });

      var image = new Image();
      image.src = Ydgj;
      image.onload = () => {
        this.viewer.entities.add({
          //答题相关的绑定
          examTitle: item.examTitle,
          chooseOne: item.chooseOne,
          chooseTwo: item.chooseTwo,
          chooseThree: item.chooseThree,
          chooseFour: item.chooseFour,
          rightRadio: item.rightRadio,

          type: item.type, //类型 news or exam
          id: item.title + "^^" + item.link,
          position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 97500),
          billboard: {
            position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 97500),
            scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.8), //(1.5e2, 5.0, 1.5e7, 0.5)
            alignedAxis: Cesium.Cartesian3.ZERO,
            image: image,
          },
          label: {
            text: item.foottime + " " + item.place, //item.title,
            font: "14px monospace",
            showBackground: true,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            pixelOffset: new Cesium.Cartesian2(0.0, -image.height),
            pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
              1.5e2,
              1.0,
              1.5e7,
              0.8
            ),
            scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.1, 1.5e7, 0.0),
          },
        });
      };
    },
    addFootLine(pointArr) {
      console.log("addFootLine");
      for (var i = 0; i < pointArr.length - 1; i++) {
        let redLine = this.viewer.entities.add({
          name: "Red arrow",
          polyline: {
            positions: Cesium.Cartesian3.fromDegreesArrayHeights([
              pointArr[i].lon,
              pointArr[i].lat,
              97500,
              pointArr[i + 1].lon,
              pointArr[i + 1].lat,
              97500,
            ]),
            width: 5,
            followSurface: true,
            material: new Cesium.PolylineArrowMaterialProperty(
              Cesium.Color.RED
            ),
          },
        });
      }
    },
    addFootLineDash(pointArr) {
      console.log("addFootLineDash");
      for (var i = 0; i < pointArr.length; i++) {
        //如果是实地到达的，就是实线
        if (pointArr[i].arrive && pointArr[i].arrive == 1) {
          let redLine = this.viewer.entities.add({
            name: "Red arrow",
            polyline: {
              positions: Cesium.Cartesian3.fromDegreesArrayHeights([
                116.39153,
                39.90723,
                97500,
                pointArr[i].lon,
                pointArr[i].lat,
                97500,
              ]),
              width: 7,
              followSurface: true,
              material: new Cesium.PolylineArrowMaterialProperty(
                Cesium.Color.RED
              ),
            },
          });
        } else {
          let redLine = this.viewer.entities.add({
            name: "Red arrow",
            polyline: {
              positions: Cesium.Cartesian3.fromDegreesArrayHeights([
                116.39153,
                39.90723,
                97500,
                pointArr[i].lon,
                pointArr[i].lat,
                97500,
              ]),
              width: 2,
              followSurface: true,
              material: new Cesium.PolylineDashMaterialProperty({
                color: Cesium.Color.RED,
              }),
            },
          });
        }
      }
    },

    //时代新人的cesium路线
    showsdxrRoute(slescttiff) {
      this.sdxrsubmit = false;

      this.sdxrviewer.entities.removeAll();
      slescttiff.forEach((item) => {
        console.log(item);
        this.addsdxrFootPrint(item);
      }, this);

      this.addsdxrFootLineDash(slescttiff);
      this.sdxrviewer.camera.setView({
        // Cesium的坐标是以地心为原点，一向指向南美洲，一向指向亚洲，一向指向北极州
        // fromDegrees()方法，将经纬度和高程转换为世界坐标
        destination: Cesium.Cartesian3.fromDegrees(
          126.61993,
          45.701417,
          5000000.0
        ),
        orientation: {
          // 指向
          heading: 6.283185307179581,
          // 视角
          pitch: -1.5688168484696687,
          roll: 0.0,
        },
      });
    },
    addsdxrFootPrint(item) {
      var image = new Image();
      image.src = Ydgj;
      image.onload = () => {
        this.sdxrviewer.entities.add({
          //答题相关的绑定
          examTitle: item.examTitle,
          chooseOne: item.chooseOne,
          chooseTwo: item.chooseTwo,
          chooseThree: item.chooseThree,
          chooseFour: item.chooseFour,
          rightRadio: item.rightRadio,

          type: item.type, //类型 news or exam
          id: item.title + "^^" + item.link,
          position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 97500),
          billboard: {
            position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 97500),
            scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.8), //(1.5e2, 5.0, 1.5e7, 0.5)
            alignedAxis: Cesium.Cartesian3.ZERO,
            image: image,
          },
          label: {
            text: item.foottime + " " + item.place, //item.title,
            font: "14px monospace",
            showBackground: true,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            pixelOffset: new Cesium.Cartesian2(0.0, -image.height),
            pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
              1.5e2,
              1.0,
              1.5e7,
              0.8
            ),
            scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.1, 1.5e7, 0.0),
          },
        });
      };
    },
    addsdxrFootLine(pointArr) {
      console.log("addFootLine");
      for (var i = 0; i < pointArr.length - 1; i++) {
        let redLine = this.sdxrviewer.entities.add({
          name: "Red arrow",
          polyline: {
            positions: Cesium.Cartesian3.fromDegreesArrayHeights([
              pointArr[i].lon,
              pointArr[i].lat,
              97500,
              pointArr[i + 1].lon,
              pointArr[i + 1].lat,
              97500,
            ]),
            width: 5,
            followSurface: true,
            material: new Cesium.PolylineArrowMaterialProperty(
              Cesium.Color.RED
            ),
          },
        });
      }
    },
    addsdxrFootLineDash(pointArr) {
      console.log("addFootLineDash");
      for (var i = 0; i < pointArr.length; i++) {
        //如果是实地到达的，就是实线
        if (pointArr[i].arrive && pointArr[i].arrive == 1) {
          let redLine = this.sdxrviewer.entities.add({
            name: "Red arrow",
            polyline: {
              positions: Cesium.Cartesian3.fromDegreesArrayHeights([
                116.39153,
                39.90723,
                97500,
                pointArr[i].lon,
                pointArr[i].lat,
                97500,
              ]),
              width: 7,
              followSurface: true,
              material: new Cesium.PolylineArrowMaterialProperty(
                Cesium.Color.RED
              ),
            },
          });
        } else {
          let redLine = this.sdxrviewer.entities.add({
            name: "Red arrow",
            polyline: {
              positions: Cesium.Cartesian3.fromDegreesArrayHeights([
                116.39153,
                39.90723,
                97500,
                pointArr[i].lon,
                pointArr[i].lat,
                97500,
              ]),
              width: 2,
              followSurface: true,
              material: new Cesium.PolylineDashMaterialProperty({
                color: Cesium.Color.RED,
              }),
            },
          });
        }
      }
    },
    //义诊路线
    yzRoute() {
      //这里用义诊数据
      this.showsdxrRoute(this.tlff);
    },
    //下乡路线
    XRoute() {
      //这里用下乡数据
      this.showsdxrRoute(this.out);
    },
    showcesium(e) {
      console.log(e.name);
      if (e.name == "2021届") {
        this.showRoute(this.out);
      } else if (e.name == "2020届") {
        this.showRoute(this.redData);
      } else {
        this.showRoute(this.inData);
      }
    },
  },
  watch: {
    searchLongjiangValue: function (newVal, oldVal) {
      console.log("longjiang change");
      console.log(oldVal);
      console.log(newVal);
      if (newVal == "") {
        this.longjiangPlaces = this.allLongjiangPlaces;
      } else {
        this.longjiangPlaces = this.allLongjiangPlaces.filter(
          (item) => item.placename.indexOf(newVal) != -1
        );
      }
    },
    searchChinaValue: function (newVal, oldVal) {
      console.log("china change");
      console.log(oldVal);
      console.log(newVal);
      if (newVal == "") {
        this.places = this.allPlaces;
      } else {
        this.places = this.allPlaces.filter(
          (item) => item.placename.indexOf(newVal) != -1
        );
      }
    },
    searchGaigeValue: function (newVal, oldVal) {
      console.log("gaige change");
      console.log(oldVal);
      console.log(newVal);
      if (newVal == "") {
        this.gaigePlaces = this.allGaigePlaces;
      } else {
        this.gaigePlaces = this.allGaigePlaces.filter(
          (item) => item.placename.indexOf(newVal) != -1
        );
      }
    },
    searchShzyValue: function (newVal, oldVal) {
      console.log("shzy change");
      console.log(oldVal);
      console.log(newVal);
      if (newVal == "") {
        this.shzyPlaces = this.allShzyPlaces;
      } else {
        this.shzyPlaces = this.allShzyPlaces.filter(
          (item) => item.placename.indexOf(newVal) != -1
        );
      }
    },
    selected: function (newVal, oldVal) {
      console.log("newVal", newVal);
      if (newVal == 2) {
        this.$refs.gsyzdropdown.showflase();
        this.$refs.sdxrdropdown.showflase();
        this.$refs.tlffdropdown.showflase();
        this.popupVisibleLongjiang = false;
        this.popupVisibleGaige = false;
        this.popupVisibleTlff = false;
        //leaflet地图在选项卡中不正常显示  http://www.bubuko.com/infodetail-1905601.html
        // L.Util.requestAnimFrame(
        //   this.mapChina.invalidateSize,
        //   this.mapChina,
        //   !1,
        //   this.mapChina._container
        // );
      }
      if (newVal == 1) {
        //高山仰止
        this.$refs.sdxrdropdown.showflase();
        this.$refs.bnfhdropdown.showflase();
        this.$refs.tlffdropdown.showflase();
        this.popupVisibleChina = false;
        this.popupVisibleGaige = false;
        this.popupVisibleTlff = false;
        //leaflet地图在选项卡中不正常显示  http://www.bubuko.com/infodetail-1905601.html
      }
      if (newVal == 3) {
        this.$refs.gsyzdropdown.showflase();
        this.$refs.bnfhdropdown.showflase();
        this.$refs.tlffdropdown.showflase();
        this.popupVisibleChina = false;
        this.popupVisibleLongjiang = false;
        this.popupVisibleTlff = false;
        //leaflet地图在选项卡中不正常显示  http://www.bubuko.com/infodetail-1905601.html
        // L.Util.requestAnimFrame(
        //   this.mapGaige.invalidateSize,
        //   this.mapGaige,
        //   !1,
        //   this.mapGaige._container
        // );
        this.sdxrviewer.scene.globe.depthTestAgainstTerrain = true;
        this.sdxrviewer._cesiumWidget._creditContainer.style.display = "none";
        ////////////////////////////////////////////////////////////////////////////////////////////////
        //添加天地图地图作为底图
        let sdxrimageryLayers = this.sdxrviewer.imageryLayers;
        let sdxrbaseLayer = sdxrimageryLayers.get(0);
        //天地图密码
        //tk=b256e08b9f972a2c4677ab5608a305ff
        let sdxrurl =
          "http://{s}.tianditu.com/img_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=img&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";
        let sdxrurl1 =
          "http://{s}.tianditu.com/cva_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=cva&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";

        sdxrimageryLayers.addImageryProvider(
          new Cesium.WebMapTileServiceImageryProvider({
            url: sdxrurl,
            layer: "img",
            style: "default",
            format: "tiles",
            tileMatrixSetID: "w",
            // credit: new Cesium.Credit('天地图全球影像服务'),
            subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
            maximumLevel: 10,
          }),
          1
        );

        sdxrimageryLayers.addImageryProvider(
          new Cesium.WebMapTileServiceImageryProvider({
            url: sdxrurl1,
            layer: "cva",
            style: "default",
            format: "tiles",
            tileMatrixSetID: "w",
            // credit: new Cesium.Credit('天地图全球影像服务'),
            subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
            maximumLevel: 10,
          }),
          2
        );

        sdxrimageryLayers.remove(sdxrbaseLayer);
      }
      if (newVal == 4) {
        this.$refs.gsyzdropdown.showflase();
        this.$refs.bnfhdropdown.showflase();
        this.$refs.bnfhdropdown.showflase();
        this.popupVisibleChina = false;
        this.popupVisibleLongjiang = false;
        this.popupVisibleGaige = false;

        this.viewer.scene.globe.depthTestAgainstTerrain = true;
        this.viewer._cesiumWidget._creditContainer.style.display = "none";
        ////////////////////////////////////////////////////////////////////////////////////////////////
        //添加天地图地图作为底图
        let imageryLayers = this.viewer.imageryLayers;
        let baseLayer = imageryLayers.get(0);
        //天地图密码
        //tk=b256e08b9f972a2c4677ab5608a305ff
        let url =
          "http://{s}.tianditu.com/img_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=img&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";
        let url1 =
          "http://{s}.tianditu.com/cva_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=cva&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";

        imageryLayers.addImageryProvider(
          new Cesium.WebMapTileServiceImageryProvider({
            url: url,
            layer: "img",
            style: "default",
            format: "tiles",
            tileMatrixSetID: "w",
            // credit: new Cesium.Credit('天地图全球影像服务'),
            subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
            maximumLevel: 10,
          }),
          1
        );

        imageryLayers.addImageryProvider(
          new Cesium.WebMapTileServiceImageryProvider({
            url: url1,
            layer: "cva",
            style: "default",
            format: "tiles",
            tileMatrixSetID: "w",
            // credit: new Cesium.Credit('天地图全球影像服务'),
            subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
            maximumLevel: 10,
          }),
          2
        );

        imageryLayers.remove(baseLayer);

        this.showRoute(this.tlff);
      }
    },
  },
  destroyed() {
    //回到顶部
    window.removeEventListener("scroll", this.scrollToTop);
  },
  computed: {
    // 滚动区高度
    // (业务需求：手机屏幕高度减去头部标题和底部tabbar的高度，当然这2个高度也是可以动态获取的)
    scrollerHeight: function () {
      console.log("window.innerHeight", window.innerHeight);
      return window.innerHeight - 100 + "px";
    },
    scrollerWeigth: function () {
      return window.innerWidth - 100 + "px";
    },
    // swdtstyle:function(){
    //      return {
    //             '--jsmind_container-height': this.bnfhheightSize + 'px'
    //         }
    // }
  },

  created: function () {
    axios
      .get(Addr.getGoNewAPIPrefix() + "xi/listXiSubject")
      .then((res) => {
        if (res.status == 200) {
          console.log("res.data", res.data);
          console.log("200");
          //桃李芬芳数据，在redis中添加一个tlff[]
          this.tlff = res.data.fight;
          //不同年份的毕业生足迹选择
          this.enviroment = res.data.enviroment;
          this.grow = res.data.grow;
          this.inData = res.data.inData;
          this.redData = res.data.redData;
          this.out = res.data.out;

          console.log("this.tlff", this.tlff);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted: function () {
    if (window.innerWidth > cfg.widthLimit) {
      this.bnfhheightSize = 200;
    }

    // this.swdt_data()
    //检查是否是开屏按钮跳转过来的
    this.checkGoto100Special();
    let isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };
    this.isMobile = isMobile.any();
    //启动图片消失
    setTimeout(() => {
      this.startShow = false;
    }, 1000);
    //回到顶部
    window.addEventListener("scroll", this.scrollToTop);

    window.addEventListener("resize", () => {
      this.setSize();
    });

    this.setSize();

    if (window.innerWidth > cfg.widthLimit) {
      this.heightSize = 200;
    }

    this.init();

    // console.log("route is:");
    // console.log(this.$route.fullPath);
    var that = this;
    mui.plusReady(function () {
      // //首页返回键处理
      // //处理逻辑：1秒内，连续两次按返回键，则退出应用；
      var first = null;
      mui.back = function () {
        //首次按键，提示  再按一次退出应用
        if (!first) {
          if (
            that.$route.fullPath == "/index" ||
            that.$route.fullPath == "/list" ||
            that.$route.fullPath == "/course" ||
            that.$route.fullPath == "/my" ||
            that.$route.fullPath == "/party20" ||
            that.$route.fullPath == "/centennialpolicy"
          ) {
            first = new Date().getTime(); //记录第一次按下回退键的时间
            mui.toast("再按一次退出应用"); //给出提示
          } else {
            history.go(-1); //回退到上一页面
          }

          setTimeout(function () {
            //1s中后清除
            first = null;
          }, 1000);
        } else {
          if (new Date().getTime() - first < 1000) {
            //如果两次按下的时间小于1s，
            plus.runtime.quit(); //那么就退出app
          }
        }
      };
    });
  },
};
</script>

<style lang="scss">
@import "../assets/baseScss";
@media screen and (min-width: 800px) {
  .abc {
    height: 500px !important;
  }
}

.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.v-enter-active,
.v-leave-active {
  transition: all 1.2s ease;
}

a.leaflet-popup-close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 4px 0 0;
  border: none;
  text-align: center;
  width: 18px;
  height: 14px;
  font: 16px/14px Tahoma, Verdana, sans-serif;
  color: #c3c3c3;
  text-decoration: none;
  font-weight: bold;
  background: transparent;
}
//隐藏放大缩小
.leaflet-left {
  display: none;
}

.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.indexHeader {
  height: 200px;
  position: relative;
}
.indexHeader {
  .search {
    position: absolute;
    z-index: 99;
    width: 90%;
    left: 5%;
    top: 10px;
    background: rgba(255, 255, 255, 0.9);
    color: $cl4;
    line-height: 35px;
    input {
      height: 35px;
      width: 65px;
      line-height: 35px;
      background: transparent;
      border: none;
      font-size: 16px;
      padding: 0 1px;
    }
    input:focus {
      outline: medium;
      width: 85%;
    }
    i:before {
      position: relative;
      font-size: 16px;
      top: 1px;
      left: 3px;
    }
  }
}

.Lsimg {
  min-width: 100%;
  min-height: 100%;
  display: block;
}
.wldimg {
  min-width: 100%;
  min-height: 100%;
  display: block;
}

.mint-swipe {
  width: 100%;
  height: 100%;
}

.prebutton {
  align-items: center;
  left: 0%;
  font-weight: 600;
  padding: 5px;
  text-align: center;
  height: 30px;
  line-height: 20px;
  width: 30px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.363);
  position: absolute;
  bottom: 50%;
}
.nextbutton {
  align-items: center;
  right: 0%;
  font-weight: 600;
  padding: 5px;
  text-align: center;
  height: 30px;
  line-height: 20px;
  width: 30px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.363);
  position: absolute;
  bottom: 50%;
}
.desc {
  left: 0;
  font-weight: 600;
  padding: 5px;
  text-align: center;
  height: 18px;
  line-height: 20px;
  width: 100%;
  color: #fff;
  background-color: rgba(255, 0, 0, 0.782);
  position: absolute;
  bottom: 0;
}
.custom-indicator {
  right: 0;
  font-weight: 600;
  padding: 2px;
  text-align: center;
  height: 18px;
  line-height: 20px;
  width: 5%;
  color: #fff;
  background-color: black;
  position: absolute;
  bottom: 30px;
}
#jsmind_container {
  align-items: center;
  //  height: var(--jsmind_container-height);
  height: 100%;
  width: 100%;
  left: 0%;
  top: 0%;
  margin: 0%;
  right: 0%;
  bottom: 0%;
}
.my-swipe .van-swipe-item {
  color: #fff;
  height: 100%;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}

.wldwrapper-content {
  width: 100%;
  height: 33%;
  text-align: center;
}
.lsbqcss {
  width: 99%;
  height: 99%;
  border: solid 3px pink;
  position: absolute;
  border-radius: 10px;
  overflow-y: auto;
}
a.leaflet-popup-close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 4px 0 0;
  border: none;
  text-align: center;
  width: 18px;
  height: 14px;
  font: 16px/14px Tahoma, Verdana, sans-serif;
  color: #c3c3c3;
  text-decoration: none;
  font-weight: bold;
  background: transparent;
}

.wkpop {
  width: 100%;
  height: calc(100% - 55px);

  margin-top: 15px;
  margin-bottom: 5px;
  border: solid 3px pink;
  border-top-left-radius: 15px;
  overflow-y: auto;
  overflow-x: hidden;
}
img {
  /* width: 100%; */
  height: 100%;
}

.box {
  border: solid 1px #a94f8a94;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/module-school100/index.vue